<template>
    <div class="badge" :style="style" :data-tooltip="tooltip" @click="badgeClick">
        <span>{{ userInitial }}</span>
    </div>
</template>

<script>
  export default {

    props: {
      username: {
        type: String,
        required: true,
        default: ''
      },
      initials: {
        type: String
      },
      backgroundColor: {
        type: String
      },
      color: {
        type: String
      },
      lighten: {
        type: Number,
        default: 80
      },
      useTooltip: {
        type: Boolean,
        default: true
      }
    },

    data () {
      return {
        backgroundColors: [
          '#65CCB8',
          '#B8A2FE',
          '#F48E7E',
          '#FB7373',
          '#81C1F2',
          '#82C0D0',
          '#EC80AF',
          '#5783C8',
          '#FFB244',
          '#A8A879',
          '#409FB8',
          '#D6AF85',
          '#AD80AF',
          '#839098',
          '#C36D9B',
          '#B7D293',
          '#BFB2A1',
          '#F0AA77',
          '#8CC07A',
          '#8CACAF']
      }
    },

    mounted () {
      this.$emit('badge-initials', this.username, this.userInitial)
    },

    computed: {
      background () {
        return this.backgroundColor ||
          this.randomBackgroundColor(this.username.length, this.backgroundColors)
      },

      fontColor () {
        return this.color || this.lightenColor(this.background, this.lighten)
      },

      style () {
        const style = {}

        const initialBackgroundAndFontStyle = {
          backgroundColor: this.background,
          color: this.fontColor
        }

        const backgroundAndFontStyle = initialBackgroundAndFontStyle

        Object.assign(style, backgroundAndFontStyle)

        return style
      },

      userInitial () {
        return this.initials || this.initial(this.username)
      },

      tooltip () {
        return this.useTooltip ? this.username : null
      }

    },

    methods: {
      initial (username) {
        let parts = username.split(/[ -]/)
        let initials = ''

        for (let i = 0; i < parts.length; i++) {
          initials += parts[i].charAt(0)
        }

        if (initials.length > 1 && initials.search(/[A-Z]/) !== -1) {
          initials = initials.replace(/[a-z]+/g, '')
        }

        initials = initials.substr(0, 1).toUpperCase()

        return initials
      },

      randomBackgroundColor (seed, colors) {
        return colors[seed % (colors.length)]
      },

      lightenColor (hex, amt) {
        let usePound = false

        if (hex[0] === '#') {
          hex = hex.slice(1)
          usePound = true
        }

        let num = parseInt(hex, 16)
        let r = (num >> 16) + amt

        if (r > 255) r = 255
        else if (r < 0) r = 0

        let b = ((num >> 8) & 0x00FF) + amt

        if (b > 255) b = 255
        else if (b < 0) b = 0

        let g = (num & 0x0000FF) + amt

        if (g > 255) g = 255
        else if (g < 0) g = 0

        return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16)
      },

      badgeClick (e) {
        this.$emit('badgeClick', e)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/widgets/BadgeWidget.vue